export default __webpack_public_path__ + "static/media/PaikangEntranceMap.0e62c425.jpg";